import React from 'react'
import { Highlight } from 'react-instantsearch-hooks-web'

export const Hit = ({ hit }) => {
  return (
    <tbody data-testid={`hit-product-${hit.ProductId}`}>
      <td data-testid={`hit-product-name-${hit.ProductId}`}>
        <Highlight attribute="ProductName" hit={hit} />
      </td>
    </tbody>
  )
}
